var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-4122.374 -1538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 16,
    height: 16,
    transform: "translate(4122.374 1538)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M4135.8,1545.954a.707.707,0,0,0-.81.6,4.568,4.568,0,0,1-1.3,2.581,4.637,4.637,0,0,1-6.557-6.557,4.576,4.576,0,0,1,2.5-1.283,4.4,4.4,0,0,1,1.318-.04,4.59,4.59,0,0,1,1.759.591l-.929.158a.714.714,0,0,0,.241,1.407l2.49-.426a.712.712,0,0,0,.582-.824l-.426-2.489a.713.713,0,1,0-1.406.241l.112.655a6.007,6.007,0,0,0-2.261-.731,5.78,5.78,0,0,0-1.732.053,5.979,5.979,0,0,0-3.256,1.68,6.063,6.063,0,0,0,8.574,8.574,5.981,5.981,0,0,0,1.708-3.382A.712.712,0,0,0,4135.8,1545.954Z",
    fill: "#636b91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.3578c1cfeae4fac1b50a662280ff3766.svg";
export { ForwardRef as ReactComponent };